import { RG_TYPE as t, getRgObjectsOfType as p } from "@project-rouge/rg-core";
import { queryPivot as r } from "../../../utils/index25.js";
import { getRgObjectsAtLevel as m } from "../../../utils/rg-util/index3.js";
const v = (i, n) => {
  const o = m(i, t.Apartment, n)[0];
  if (o === void 0)
    return 0;
  const e = p(o, t.Module)[0], l = r({ obj: e, type: t.Floor, pivot: [0, 1, 0] }).y;
  return r({ obj: e, type: t.Ceiling, pivot: [0, 0, 0] }).y - l;
};
export {
  v as getLevelClearInternalHeight
};
//# sourceMappingURL=index9.js.map
